import React from 'react';
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import { useNavigate } from 'react-router-dom';
import MapPin from '../../../assets/images/pin.svg';
import TrustMapPin from '../../../assets/images/trust_location.svg';

const WorshipLocationMap = ({ organisation, worshipLocations }) => {
  const navigate = useNavigate();
  const onMarkerClicked = (worshipLocationId) => {
    navigate(`/worship-locations/${worshipLocationId}/?mapview=true`);
  };

  return (
    <div style={{ height: 'calc(100vh - 230px)', paddingTop: '15px' }}>
      <APIProvider
        apiKey={'AIzaSyAQgLJQfu0gk57s8xHpqtKJhUovUCjQvGA'}
        onError={(err) => {
          console.warn(err);
        }}
      >
        <Map
          mapId={'49836489bb08f0cdadb9c9b8'}
          defaultCenter={{ lat: organisation.latitude, lng: organisation.longitude }}
          defaultZoom={15}
          gestureHandling={'greedy'}
          disableDefaultUI={true}
        >
          <AdvancedMarker position={{ lat: organisation.latitude, lng: organisation.longitude }}>
            <img src={TrustMapPin} alt={'trust location'} />
          </AdvancedMarker>
          {worshipLocations.map((worship) => {
            if (worship.lat === 0 && worship.lng === 0) return null;
            return (
              <AdvancedMarker
                clickable
                position={{ lat: worship.lat, lng: worship.lng }}
                onClick={() => onMarkerClicked(worship.id)}
              >
                <img src={MapPin} alt={'worship location'} />
              </AdvancedMarker>
            );
          })}
        </Map>
      </APIProvider>
    </div>
  );
};

export default WorshipLocationMap;
